// business-owner.actions.ts
import { createActionGroup, props } from '@ngrx/store'
import { BusinessLogFilters, TaskLog } from './task-log.state'

export const activityLogActions = createActionGroup({
  source: 'Activity Log',
  events: {
    'Load My Logs': props<{ userId: string; page: number; limit: number }>(),
    'Load My Logs Success': props<{ tasklogs: TaskLog[]; totalCount: number }>(),
    'Load My Logs Failure': props<{ error: string }>(),

    'Load Business Logs': props<{
      businessId: string
      page: number
      limit: number
      filters: BusinessLogFilters
    }>(),
    'Load Business Logs Success': props<{
      businessTasklogs: TaskLog[]
      totalBusinessLogCount: number
    }>(),
    'Load Business Logs Failure': props<{ error: string }>()
  }
})
